import React from 'react'
import { withRouter } from 'react-router'
import Footer from '../../components/Footer'
import ReviewCard from '../../components/ReviewCard/ReviewCard'
import HomeHeader from '../../components/HomePageHeader'
import ExamplesGrid from '../../Examples/components/ExamplesGrid/ExamplesGrid'
import examples from '../../Landing/UseCases/UseCases.json'
import { toggleSignUpModal } from '../../Manage/actions'
import CTAButton from '../../components/CTAButton/CTAButton'
import FAQ from '../../Landing/FAQ/FAQ'

import styles from './ReferralLanding.module.css'
import { useDispatch } from 'react-redux'

const ExamplesSection = ({ history, examples }) => {
  return (
    <div className="container mt-5 mb-5 text-center">
      <div className="d-flex flex-column align-items-center mb-lg-5">
        <h1 className="gradient-text w-75 font-weight-900 font-47">A tiiny tool with endless possibilities</h1>
        <p className="grey text-start font-20 p-4">
          You can use tiiny to share many different types of documents, files or projects online.
        </p>
      </div>
      <ExamplesGrid examples={examples} history={history} align="center" />
    </div>
  )
}

const AboveFold = () => {
  const dispatch = useDispatch()

  return (
    <div className="container-lg mt-5 mb-5 d-lg-flex d-column align-items-center mt-5 p-4">
      <div className={styles.titleContainer}>
        <h1 className={`${styles.h1} black`}>The Simplest Way To Share Your Work Online</h1>
        <p className="grey text-start font-20 mt-4">
          Drag & drop 80+ file types to get a shareable link in seconds. <br />
          <br />
          <b>It's really that simple.</b>
        </p>
        <CTAButton
          className="mt-4"
          label="Sign up free"
          onClick={() => dispatch(toggleSignUpModal(true))}
          variant="primary-gradient-round"
          size="large"
        />
      </div>
      <div className="box round-20 d-lg-block d-none">
        <img src="/assets/img/demo.gif" height="400" />
      </div>
    </div>
  )
}

const ReferralLanding = ({ history }) => {
  return (
    <div className="body-bg full-height">
      <HomeHeader simplified />
      <AboveFold />
      <ReviewCard />
      <ExamplesSection history={history} examples={examples} />
      <FAQ showCTA={false} />
      <Footer simplified />
    </div>
  )
}

export default withRouter(ReferralLanding)
